import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { GamResponseI } from '@interfaces/gamResponse';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class GamService {
  login(gamToken: string) {
    const url = this.occEndpointsService.buildUrl(`${environment.B2B_PREFIX}/gamLogin?token=${gamToken}`);
    return this.http.post<GamResponseI>(url, {});
  }

  constructor(private http: HttpClient, private occEndpointsService: OccEndpointsService ) {}
}
